import { ROUTES } from "~/constants/routing";

export interface IDashboardHeading {
  h1: string;
  subtitle: string;
}

export const DASHBOARD_HEADINGS: Record<string, IDashboardHeading> = {
  [ROUTES.main.path]: {
    h1: "See what prediction markets are pricing and why.",
    subtitle:
      "Compare odds, liquidity and the news behind every move across Polymarket, Kalshi, Limitless, Opinion and more, normalized in one place. Ready to trade? The best price is one click away.",
  },
  [ROUTES.breaking.path]: {
    h1: "Breaking Prediction Markets — High-Velocity Odds",
    subtitle:
      "Odds for fast-moving events across Polymarket, Kalshi, Opinion, Limitless, and more — flagged by volume spikes.",
  },
  [ROUTES.trending.path]: {
    h1: "Trending Prediction Markets — Top-Moving Odds Right Now",
    subtitle:
      "The most actively traded prediction market events across Polymarket, Kalshi, Opinion, Limitless, and more — ranked by volume and cross-platform activity.",
  },
  [ROUTES.new.path]: {
    h1: "New Prediction Markets — Recently Listed Odds Across All Platforms",
    subtitle:
      "The most recently added prediction market events across Polymarket, Kalshi, Opinion, Limitless, and more — normalized and searchable.",
  },
  [ROUTES.endingSoon.path]: {
    h1: "Ending Soon Prediction Markets — Final Odds Before Resolution",
    subtitle:
      "Prediction market events approaching their close date across Polymarket, Kalshi, Opinion, Limitless, and more — ranked by time remaining.",
  },
  [ROUTES.binary.path]: {
    h1: "50/50 Prediction Markets — Most Uncertain Odds Across All Platforms",
    subtitle:
      "Prediction market events trading closest to 50% probability across Polymarket, Kalshi, Opinion, Limitless, and more — the market's closest calls.",
  },
  [ROUTES.multiOutcome.path]: {
    h1: "Multi-Outcome Prediction Markets — Odds for Complex Events",
    subtitle:
      "Events with more than two possible outcomes across Polymarket, Kalshi, Opinion, Limitless, and more — elections, tournaments, and scenarios in one view.",
  },
  [ROUTES.umaDisputed.path]: {
    h1: "UMA Disputed Prediction Markets — Contested Resolutions Tracked Live",
    subtitle:
      "Prediction market events under UMA oracle dispute across Polymarket and more — flagged and updated in real time until resolution is confirmed.",
  },
  [ROUTES.aggregated.path]: {
    h1: "Aggregated Prediction Markets — Cross-Platform Consensus Odds",
    subtitle:
      "Prediction market events tracked across Polymarket, Kalshi, Opinion, Limitless, and more simultaneously — normalized and searchable for divergence and consensus.",
  },
};
